import * as React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { ChevronRight } from "lucide-react";
export default function Hero() {
  const stats = [{
    value: 15,
    suffix: "",
    label: "PROYECTOS REALIZADOS"
  }, {
    value: 25000,
    suffix: " m²",
    label: "CONSTRUIDOS"
  }, {
    value: 10,
    suffix: "",
    label: "AÑOS DE TRAYECTORIA"
  }, {
    value: 1500,
    suffix: "",
    label: "UNIDADES ENTREGADAS"
  }];
  return <section data-section-id="175455" id="excelencia-en-desarrollo" className="relative min-h-[85vh] flex items-center justify-start overflow-x-hidden bg-[#0F2533] bg-cover bg-right !bg-[url(https://rudichgroup.redian.com.ar/wp-content/uploads/2026/05/newhero2.png)]">
      <div className="absolute inset-0 bg-gradient-to-r from-[#0F2533] via-[#0F2533]/80 to-transparent z-10"></div>

      <div className="container relative z-20 mx-auto px-4 md:px-6 lg:px-8 max-w-7xl">
        <div className="max-w-5xl">
          <div className="flex flex-col items-start text-left space-y-8 md:space-y-12">
            
            <div className="space-y-6 md:space-y-8">
              <div className="space-y-4 animate-in fade-in slide-in-from-bottom-8 duration-1000 delay-200">
                <h1 className="text-4xl md:text-6xl lg:text-8xl font-sans font-bold tracking-tighter uppercase text-white leading-[0.9] flex flex-col">
                  <span className="!text-5xl md:!text-6xl !font-serif">DESARROLLOS QUE TRASCIENDEN.</span>
                </h1>
              </div>

              <div className="max-w-2xl animate-in fade-in slide-in-from-bottom-10 duration-1000 delay-400">
                <p className="text-white text-lg md:text-xl lg:text-2xl font-serif leading-relaxed opacity-90">Excelencia en construcción e inversión inmobiliaria de alto nivel en Argentina.</p>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 md:gap-6 justify-start items-start pt-4 animate-in fade-in slide-in-from-bottom-12 duration-1000 delay-600 w-full sm:w-auto">
              <Button asChild size="lg" className="group w-full sm:w-auto !bg-[#e6cd93] !text-white hover:!bg-[#e6cd93]/90 transition-all duration-500 shadow-lg border-none h-16 px-12">
                <Link to="#portafolio-de-proyectos" className="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive text-primary-foreground has-[>svg]:px-4 group w-full rounded-none !text-white transition-all duration-500 shadow-lg border-none h-16 px-12 inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive text-primary-foreground has-[>svg]:px-4 group w-full rounded-none !text-white transition-all duration-500 shadow-lg border-none h-16 px-12 inline-flex items-center justify-center gap-3 text-sm font-bold uppercase tracking-widest disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-primary/90 sm:w-auto hover:!bg-[#e6cd93]/90 disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-primary/90 sm:w-auto hover:!bg-[#e6cd93]/90">
                  Ver Proyectos
                  <ChevronRight className="size-4 transition-transform duration-300 group-hover:translate-x-1" />
                </Link>
              </Button>

              <Button asChild size="lg" variant="outline" className="group w-full sm:w-auto border-2 border-white !bg-transparent !text-white hover:!bg-white hover:!text-[#0F2533] transition-all duration-500 shadow-lg h-16 px-12">
                <Link to="#canales-de-contacto" className="inline-flex items-center justify-center gap-2 text-sm font-bold uppercase tracking-widest">Contactanos</Link>
              </Button>
            </div>

            {}
            <div className="pt-8 md:pt-12 animate-in fade-in slide-in-from-bottom-16 duration-1000 delay-800 w-full">
              <div className="grid grid-cols-2 md:flex md:flex-wrap items-center gap-8 md:gap-12 justify-start">
                {stats.map((stat, i) => {
                const delays = ["delay-200", "delay-300", "delay-400", "delay-500"];
                return <React.Fragment key={i}>
                      <div data-index={i} className={`flex flex-col items-start animate-in fade-in slide-in-from-bottom-4 duration-1000 ${delays[i] || "delay-200"}`}>
                        <span className="text-3xl font-sans font-bold !text-[hsl(0,0%,100%)] md:text-4xl">
                          +{stat.value}{stat.suffix}
                        </span>
                        <span className="text-[9px] md:text-[10px] font-sans font-bold uppercase tracking-widest text-white mt-1">
                          {stat.label}
                        </span>
                      </div>
                    </React.Fragment>;
              })}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-12 left-1/2 -translate-x-1/2 z-20 animate-bounce opacity-50 hidden lg:block">
        <div className="w-px h-16 bg-gradient-to-b from-white to-transparent"></div>
      </div>

      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#e6cd93]/30 to-transparent z-20"></div>
    </section>;
}